import { usePricingDomain } from "@/configurator/domain/hooks/usePricingDomain";
import type { PricingDomain } from "@/configurator/domain/hooks/usePricingDomain";

export type QuantityBarComponent = PricingDomain;

export function useQuantityBarComponent(): QuantityBarComponent {
  return usePricingDomain();
}
